<template>
  <!--新增对话框-->
  <el-dialog
    title="订单详情"
    :visible.sync="dialogVisible"
    width="1000px"
    append-to-body
    :close-on-click-modal="false"
    class="dialogClass"
  >
    <div class="flexjcen" v-for="(item, index) in tableData" :key="index">
      <div class="flexjcen">
        <img class="store" :src="item.storeGoodsCover" alt="" />
        <div class="godwin">
          <div class="sizetxt">
            {{ item.storeGoodWeight }} | {{ item.storeGoodsName }}
          </div>
          <div class="">
            {{ item.discountExplain }}
          </div>
        </div>
      </div>
      <div class="">
        <div class="sizetxt red">￥{{ item.storeGoodsPrice }}</div>
        <div class="">x {{ item.number }}</div>
      </div>
    </div>
    <div style="height: 20px"></div>
    <div class="issline"></div>
    <div style="height: 20px"></div>
    <div class="flexjcen">
      <div class="">实付款</div>
      <div class="redmony">￥{{ editForm.paymentAmount }}</div>
    </div>
    <div style="height: 20px"></div>
    <div class="issline"></div>
    <div style="height: 20px"></div>
    <div class="flexcen">
      <div class="titcon">创建时间</div>
      <div class="">
        {{ editForm.createTime }}
      </div>
    </div>
    <div class="flexcen" v-if="editForm.payTime">
      <div class="titcon">付款时间</div>
      <div class="">
        {{ editForm.payTime }}
      </div>
    </div>
    <div class="flexcen" v-if="editForm.deliveryTime">
      <div class="titcon">发货时间</div>
      <div class="">
        {{ editForm.deliveryTime }}
      </div>
    </div>
    <div class="flexcen">
      <div class="titcon">收货信息</div>
      <div class="">{{ editForm.consignee }} {{ editForm.address }}</div>
    </div>
    <div class="flexcen" v-if="editForm.trasactionId">
      <div class="titcon">交易编号</div>
      <div class="">
        {{ editForm.trasactionId }}
      </div>
    </div>
    <div class="flexcen">
      <div class="titcon">订单编号</div>
      <div class="">{{ editForm.orderNumber }}</div>
    </div>
  </el-dialog>
</template>
<script>
import VploadVideo from "../inc/VploadVideo.vue";
import TinymceEditor from "../inc/TinymceEditor";
export default {
  name: "BillDetails",
  components: {
    TinymceEditor,
    VploadVideo,
  },
  data() {
    return {
      editForm: {},
      fileList: [],
      tableData: [],
      urlList: [],
      videoList: [],
      videoUrlList: [],
      editFormRules: {
        value: [
          {
            required: true,
            message: "请选择群二维码",
            trigger: "blur",
          },
        ],
      },
      dialogVisible: false,
    };
  },
  methods: {
    change(val) {
      this.editForm.describe = val;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
      this.editForm = {};
      this.fileList = [];
      this.urlList = [];
      this.tableData = [];
      this.videoList = [];
      this.videoUrlList = [];
    },
    handleClose() {
      this.resetForm("editForm");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post(
              "/admin/mcMuseumCollection/updMcMuseumCollectionDetails",
              this.editForm
            )
            .then((res) => {
              this.$message({
                showClose: true,
                message: "恭喜你，操作成功",
                type: "success",
                onClose: () => {
                  this.$emit("refreshDataList");
                },
              });
              this.dialogVisible = false;
              this.resetForm(formName);
            });
        } else {
          return false;
        }
      });
    },
    getImgList(url, add) {
      if (add == 1) {
        this.urlList.push(url);
      } else if (add == 0) {
        if (this.urlList == null || this.urlList.length < 1) {
          return;
        }
        this.urlList.some((item, i) => {
          if (item == url) {
            this.urlList.splice(i, 1);
            //在数组的some方法中，若是return true，就会当即终止这个数组的后续循环
            return true;
          }
        });
      }
      this.editForm.filePath = this.urlList.join(",");
    },
    getvideoList() {
      if (add == 1) {
        this.videoUrlList.push(url);
      } else if (add == 0) {
        if (this.videoUrlList == null || this.videoUrlList.length < 1) {
          return;
        }
        this.videoUrlList.some((item, i) => {
          if (item == url) {
            this.videoUrlList.splice(i, 1);
            //在数组的some方法中，若是return true，就会当即终止这个数组的后续循环
            return true;
          }
        });
      }
      this.editForm.filePath = this.videoUrlList.join(",");
    },
    init(billId) {
      this.dialogVisible = true;
      if (billId != null && billId != "") {
        this.$axios
          .post("/sysOrder/selectOrderDetail", {
            orderId: billId,
          })
          .then((res) => {
            this.editForm = res.data;
            this.tableData = res.data.sysOrderStoreGoodsVos;
            // if (res.data.filePathList&&res.data.filePathList.length>0){
            //     res.data.filePathList.forEach((item, index)=>{
            //         var filess={url:item}
            //         this.fileList.push(filess)
            //     })
            //     this.urlList=res.data.filePathList;
            // }
            // if (res.data.videoFilePathList&&res.data.videoFilePathList.length>0){
            //     res.data.videoFilePathList.forEach((item, index)=>{
            //         var filess={url:item}
            //         this.videoList.push(filess)
            //     })
            //     this.videoUrlList=res.data.videoFilePathList;
            // }
          });
      }
    },
  },
};
</script>

<style scoped>
.flexjcen {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flexcen {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.store {
  width: 60px;
  height: 60px;
  border-radius: 6px;
}

.godwin {
  padding-left: 10px;
}

.sizetxt {
  height: 40px;
  line-height: 20px;
  font-size: 14px;
}

.red {
  color: #d9001b;
  font-weight: 800;
  font-size: 16px;
}

.issline {
  height: 1px;
  background: #e1e1e1;
  width: 100%;
}

.redmony {
  color: #d9001b;
  font-size: 16px;
}

.titcon {
  width: 150px;
}
</style>
